/* eslint-disable no-alert */
/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import {
  DataGrid,
  GridLogicOperator,
  gridClasses,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridRowModes,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import Box from '@mui/material/Box';
import { Paper, Tooltip } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import ItemMasterRowAdd from './ItemMasterRowAdd';
import LoadingOverlay from '../components/LoadingOverlay';

const useStyles = makeStyles({
  columnsButton: {
    scale: 1.25,
    padding: '8px', // customize the padding to adjust the size
  },
});
// const LoginInfo = JSON.parse(localStorage.getItem('loginID')) || '';
// const hasInsertItemMaster = LoginInfo.skuDetail?.some((item) => item?.PageName === 'Insert Item Master');
function CustomToolbar(tableData1, SKUTable) {
  const classes = useStyles();
  return (
    <div className="container-fluid">
      <div className="row" id="table_feature">
        <GridToolbarContainer>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarColumnsButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarDensitySelector className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarFilterButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: 'Item Master',
              }}
              className={classes.columnsButton}
            />
          </div>
          <div id="quick_search">
            <GridToolbarQuickFilter />
          </div>
          <div>
            <ItemMasterRowAdd tableData={tableData1} runSKUTable={SKUTable} />
          </div>
        </GridToolbarContainer>
      </div>
    </div>
  );
}

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY
            + theme.palette.action.selectedOpacity
            + theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const ItemMaster = () => {
  const [loading, setLoading] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [sortModel, setSortModel] = React.useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [isSaveTriggered, setIsSaveTriggered] = React.useState(false);
  // const [isDisable, setIsDisable] = React.useState(false);

  const { activeMenu } = useStateContext(); // themeSettings, fileData2, setFileData2
  const navigate = useNavigate();
  const isMounted = useRef(false);

  const LoginInfo = JSON.parse(localStorage.getItem('loginID')) || '';
  const handleRowModesModelChange = (newRowModesModel) => {
    // debugger;
    setRowModesModel(newRowModesModel);
  };

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        SKUTable();
      }
    }
  }, []);

  const UpsActionSave = async (updatedRow, newRow, action) => {
    // debugger;
    setLoading(true);
    const raw = {
      // IDXList: updatedRow.IDX.toString(),
      // Status: updatedRow.CCSAction || '',
      // UPSValue: updatedRow.UPS_SVC || '',
      UserId: LoginInfo.UserId,
      UserName: LoginInfo.UserName,
      ProcessName: LoginInfo.ProcessName,
      PageName: 'Update Item Master',
      Item_ID: updatedRow.Item_ID || '',
      API_Integration: updatedRow.API_Integration || '',
      Receipt_reported_to_SimpliSafe:
        updatedRow.Receipt_reported_to_SimpliSafe || '',
      Keep_upon_receipt: updatedRow.Keep_upon_receipt || '',
      Under_max_inventory_level: updatedRow.Under_max_inventory_level || '',
      Pass_visual_inspection: updatedRow.Pass_visual_inspection || '',
      Refurb_process_defined: updatedRow.Refurb_process_defined || '',
      Refurb_process_active: updatedRow.Refurb_process_active || '',
      Inventory_target: updatedRow.Inventory_target === null ? '' : updatedRow.Inventory_target,
      Quality_Testing_Program: updatedRow.Quality_Testing_Program || '',
      Sort_Criteria: updatedRow.Sort_Criteria || '',
      Like_New: updatedRow.Like_New || '',
      Tamper_Seal: updatedRow.Tamper_Seal || '',
      CCR: updatedRow.CCR || '',
      Action: action || 'Update',
      TopChainSKU: updatedRow.TopChainSKU || '',
      SerialNumberCaptureRequired: updatedRow.SerialNumberCaptureRequired || '',
    };

    try {
      const response = await axios.post(
        `${variables.BASE_URL}UpdateItemMaster`,
        raw,
      );
      const Data = response.data;
      // console.log(Data);
      if (Data?.IsSuccess) {
        // debugger;
        sessionStorage.setItem('rowUpdate', JSON.stringify(Data));
        setRowModesModel({
          ...rowModesModel,
          [newRow.id]: { mode: GridRowModes.View },
        });
        Swal.fire({
          icon: 'success',
          title: 'Done',
          text: 'Successfully Updated.',
        });
      } else if (!Data?.IsSuccess) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      } else if (Data?.IsAuthorize !== true) {
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      }
    } catch (error) {
      // console.error('Error:', error);
    }
    setLoading(false);
  };

  const handleSelectionModelChange = (newSelection) => {
    setRowSelectionModel(newSelection);
  };
  const handleProcessRowUpdateError = (error) => {
    // debugger;
    alert(error.message);
  };
  const processRowUpdate = async (newRow, oldRow) => {
    debugger;
    const isItemIDMatch = tableData1.some(
      (item) => item.Item_ID === newRow.TopChainSKU.trim().toUpperCase(),
    );

    if (isSaveTriggered) {
      if (!isItemIDMatch && newRow.TopChainSKU.toUpperCase() !== '') {
        const updatedTableData = tableData1.map((row) => (row.id === oldRow.id ? oldRow : row));
        setTableData1(updatedTableData);
        throw new Error('The Top Chain SKU is not valid.');
      }
      const isValid = /^([0-9]*)?$/.test(newRow.Inventory_target);
      if (newRow.Inventory_target) {
        if (!isValid) {
          // If invalid, revert all values to previous state
          const updatedTableData = tableData1.map((row) => (row.id === oldRow.id ? oldRow : row));
          setTableData1(updatedTableData);
          throw new Error(
            'Only possitive numbers are allowed for Inventory target.',
          );
        }
      }
      const updatedRow = { ...newRow, isNew: false };
      if (updatedRow.id === newRow.id) {
        await UpsActionSave(updatedRow, newRow, 'Update');
        // const updatedVar = JSON.parse(sessionStorage.getItem('rowUpdate'));
        // console.log(updatedVar);
        const updatedTableData = tableData1.map((row) => (row.id === updatedRow.id ? updatedRow : row));
        setTableData1(updatedTableData);
      }
      setIsSaveTriggered(false);
      return updatedRow;
    }
    return oldRow;
  };

  const handleRowEditStop = (params, event) => {
    // debugger;
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleRowEditStart = (params, event) => {
    // debugger;
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => () => {
    // debugger;
    // const IsNo = tableData1.filter((i) => i.id === id)[0]?.Keep_upon_receipt;
    // if (IsNo !== 'NO') {
    //   setIsDisable(false);
    // }
    // console.log(rowModesModel, GridRowModes);
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => async () => {
    setIsSaveTriggered(true); // Indicate save action
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCancelClick = (id) => {
    // setIsDisable(false);// update this flag to show values where neede(default)
    setIsSaveTriggered(false); // Reset save flag
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const SKUTable = async () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      UserId:
        JSON.parse(localStorage.getItem('loginID')) === null || undefined
          ? null
          : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Item Master',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    await fetch(`${variables.BASE_URL}SKUSetup`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // console.log(JSON.parse(result))
        // debugger
        if (
          JSON.parse(result)?.IsSuccess !== false
          && JSON.parse(result)?.IsAuthorize !== false
        ) {
          const initialData = JSON.parse(result).SKUSetup.map((row, index) => ({
            ...row,
            id: index + 1,
          }));
          setTableData1(initialData);
        }
        if (
          JSON.parse(result)?.IsSuccess !== true
          && JSON.parse(result)?.IsAuthorize
        ) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData1([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };
  // console.log(tableData1);
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteRecord(id);
      }
    });
  };

  const DeleteRecord = async (id) => {
    const filteredArray = tableData1.find((item) => item.id === id);
    setLoading(true);
    try {
      const requestBody = {
        UserId: LoginInfo.UserId,
        UserName: LoginInfo.UserName,
        ProcessName: LoginInfo.ProcessName,
        PageName: 'Delete Item Master',
        Action: 'Delete',
        Item_ID: filteredArray.Item_ID,
      };

      const response = await axios.post(
        `${variables.BASE_URL}DeleteItemMaster`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      if (!response.data.IsSuccess) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.Reason || 'Something went wrong.',
        });
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Done',
          text: 'Successfully Deleted row.',
          allowOutsideClick: false,
        });
      }
      // update table rows only after success
      const updatedRows = tableData1.filter((row) => row.id !== id);
      setTableData1(updatedRows);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const processEditCellProps = (params, action) => {
    // console.log(params, action);
    if (action === 'Keep_upon_receipt') {
      // debugger;
      // Update the row to disable other fields based on the value of Keep_upon_receipt
      if (params.props.value === 'NO') {
        params.otherFieldsProps.Pass_visual_inspection.value = 'NA';
      }
      setTableData1((prevData) => {
        const updatedRows = prevData.map((row) => (row.id === params.id
          ? { ...row, disableOtherFields: params.props.value === 'NO' } // Update disableOtherFields flag
          : row));
        return updatedRows;
      });
    }
    // debugger;
    return params.props; // Return the updated params
  };
  // console.log(isDisable);
  const inventoryTooltip = (
    <div>
      <div>Blank / Empty value means there is no inventory target.</div>
      <div style={{ marginTop: 4 }}>
        <strong>0</strong> represents auto scrap because the inventory target has been reached.
      </div>
    </div>
  );
  const column = [
    {
      field: 'actions',
      type: 'actions',
      headerName: '',
      width: 150,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        // console.log(id);
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const isStatus = tableData1.filter((row) => row.id === id);
        // console.log(isStatus);
        const hasUpdateItemMaster = LoginInfo.skuDetail.some(
          (item) => item.PageName === 'Update Item Master',
        );
        const hasDeleteItemMaster = LoginInfo.skuDetail.some(
          (item) => item.PageName === 'Delete Item Master',
        );
        // console.log(hasDeleteItemMaster);
        if (hasUpdateItemMaster && isStatus[0].IsEditableOnPortal) {
          if (isInEditMode) {
            return [
              <Tooltip
                title="Save"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'grey.800',
                      '& .MuiTooltip-arrow': {
                        color: 'grey.800',
                      },
                      fontSize: '1rem', // 16px
                      padding: '10px 16px',
                      fontWeight: 500,
                    },
                  },
                }}
              >
                <GridActionsCellItem
                  icon={<SaveIcon />}
                  label="Save"
                  sx={{
                    color: 'primary.main',
                  }}
                  onClick={handleSaveClick(id)}
                />
              </Tooltip>,
              <Tooltip
                title="Cancel"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'grey.800',
                      '& .MuiTooltip-arrow': {
                        color: 'grey.800',
                      },
                      fontSize: '1rem',
                      padding: '10px 16px',
                      fontWeight: 500,
                    },
                  },
                }}
              >
                <GridActionsCellItem
                  icon={<CancelPresentationIcon />} // Use the Cancel icon from Material-UI
                  label="Cancel"
                  sx={{
                    color: 'error.main',
                  }}
                  onClick={() => handleCancelClick(id)}
                />
              </Tooltip>,
            ];
          }
          return [
            <Tooltip
              key="edit"
              title="Edit"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: 'grey.800',
                    '& .MuiTooltip-arrow': {
                      color: 'grey.800',
                    },
                    fontSize: '1rem', // 16px
                    padding: '10px 16px',
                    fontWeight: 500,
                  },
                },
              }}
            >
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
              />
            </Tooltip>,
            hasDeleteItemMaster ? (
              <Tooltip
                key="delete"
                title="Delete"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'grey.800',
                      '& .MuiTooltip-arrow': {
                        color: 'grey.800',
                      },
                      fontSize: '1rem',
                      padding: '10px 16px',
                      fontWeight: 500,
                    },
                  },
                }}
              >
                <GridActionsCellItem
                  icon={<DeleteIcon />}
                  label="Delete"
                  onClick={() => handleDelete(id)}
                  color="inherit"
                />
              </Tooltip>
            ) : null,
          ].filter(Boolean); // Filters out null or undefined elements
        }
        return [];
      },
    },
    {
      field: 'API_Integration',
      headerName: 'API Integration',
      width: 150,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['TRUE', 'FALSE'],
    },
    {
      field: 'Receipt_reported_to_SimpliSafe',
      headerName: 'Receipt reported to SimpliSafe',
      width: 225,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['TRUE', 'FALSE'],
    },
    {
      field: 'Item_ID',
      headerName: 'Item ID/SKU',
      width: 150,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'Description',
      headerName: 'Description',
      width: 250,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'SimpliSafe_ERP_Certified_Item',
      headerName: 'SimpliSafe ERP Certified Item',
      width: 225,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'CoreCentric_Certified_FG_Number',
      headerName: 'CoreCentric Certified FG Number',
      width: 250,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'Keep_upon_receipt',
      headerName: 'Keep Upon Receipt',
      width: 150,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['YES', 'NO'],
      preProcessEditCellProps: (params) => processEditCellProps(params, 'Keep_upon_receipt'), // Handle value change
    },
    {
      field: 'SizeCategory',
      headerName: 'Size Category',
      width: 110,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'Under_max_inventory_level',
      headerName: 'Under Max Inventory Level',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['y/n', 'NA'],
      preProcessEditCellProps: (params) => processEditCellProps(params, 'Under_max_inventory_level'),
    },
    {
      field: 'Pass_visual_inspection',
      headerName: 'Pass Visual Inspection',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      // valueOptions: ['y/n', 'NA'],
      // valueOptions: isDisable === false ? ['y/n', 'NA'] : ['NA'],
      valueOptions: (params) => (params.row.Keep_upon_receipt === 'YES' ? ['y/n', 'NA'] : ['NA']),
      preProcessEditCellProps: (params) => processEditCellProps(params, 'Pass_visual_inspection'),
    },
    {
      field: 'Refurb_process_defined',
      headerName: 'Refurb Process Defined',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Y', 'N', 'NA'],
      preProcessEditCellProps: (params) => processEditCellProps(params, 'Refurb_process_defined'),
    },
    {
      field: 'Refurb_process_active',
      headerName: 'Refurb Process Active',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Y', 'N', 'NA'],
    },
    {
      field: 'Inventory_target',
      headerName: 'Inventory Target',
      renderHeader: () => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Tooltip title={inventoryTooltip} arrow>
            <span
              className="MuiDataGrid-columnHeaderTitle css-t89xny-MuiDataGrid-columnHeaderTitle"// '0 value represents auto scrap because the inventory target has been reached.'
              style={{
                '--unstable_DataGrid-radius': '4px',
                '--unstable_DataGrid-headWeight': 500,
                '--unstable_DataGrid-overlayBackground': 'rgba(255, 255, 255, 0.38)',
              }}
            >Inventory Target
            </span>
            <InfoIcon
              style={{ fontSize: 16, color: '#007bff', cursor: 'pointer' }}
            />
          </Tooltip>
        </div>
      ),
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'number',
      renderCell: (params) => (
        <Tooltip title={inventoryTooltip} arrow>
          <div>
            {params.value}
          </div>
        </Tooltip>
      ),
      renderEditCell: (params) => (
        <Tooltip title={inventoryTooltip} arrow>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '8px',
              backgroundColor: '#e0f7fa',
              borderRadius: '4px',
              border: '1px dashed #007bff',
            }}
          >
            {/* <input
              type="text"
              value={params.value || ''}
              onChange={(e) => {
                params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value }, e);
              }}
              style={{
                width: '100%',
                border: 'none',
                background: 'transparent',
                outline: 'none',
                textAlign: 'left',
              }}
            /> */}
            <input
              type="text"
              inputMode="numeric" // shows numeric keyboard on mobile
              pattern="[0-9]*"
              value={params.value ?? ''}
              onChange={(e) => {
                const val = e.target.value;
                // allow blank
                if (val === '') {
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: '',
                  });
                  return;
                }
                // allow only digits 0-9
                if (/^[0-9]+$/.test(val)) {
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: Number(val),
                  });
                }
              }}
              style={{
                width: '100%',
                border: 'none',
                background: 'transparent',
                outline: 'none',
                textAlign: 'left',
              }}
            />
          </div>
        </Tooltip>
      ),
    },
    {
      field: 'Current_Inventory',
      headerName: 'Current Inventory',
      width: 150,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'Quality_Testing_Program',
      headerName: 'Quality Testing Program',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['NA', 'Y', 'N'],
    },
    {
      field: 'Sort_Criteria',
      headerName: 'Sort Criteria',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['NA', 'Y', 'N'],
    },
    {
      field: 'Like_New',
      headerName: 'Like New',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['NA', 'Y', 'N'],
    },
    {
      field: 'Tamper_Seal',
      headerName: 'Tamper Seal',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['NA', 'Y', 'N'],
    },
    {
      field: 'CCR',
      headerName: 'CCR',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['NA', 'Y', 'N'],
    },
    {
      field: 'TopChainSKU',
      headerName: 'Top Chain SKU',
      width: 150,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      renderCell: (params) => (
        <div>
          {params.value}
        </div>
      ),
      renderEditCell: (params) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: '8px',
            backgroundColor: '#e0f7fa',
            borderRadius: '4px',
            border: '1px dashed #007bff',
          }}
        >
          <input
            // type="number"
            value={params.value.toUpperCase() || ''}
            onChange={(e) => {
              params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value.toUpperCase() }, e);
            }}
            style={{
              width: '100%',
              border: 'none',
              background: 'transparent',
              outline: 'none',
              textAlign: 'left',
            }}
          />
        </div>
      ),
    },
    {
      field: 'SerialNumberCaptureRequired',
      headerName: 'Serial Number Capture Required',
      width: 250,
      headerAlign: 'left',
      align: 'left',
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Y', 'N'],
    },
  ];

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div
        style={{
          width: `${activeMenu ? '100%' : '100%'} `,
          paddingLeft: `${activeMenu ? '300px' : '0px'}`,
        }}
      >
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          id="navMenu_id"
        >
          <Navbar />
        </div>
        <div>
          <div className="container-fluid">
            <div>
              <Paper className="table_backpaper">
                {loading && <div className="fullscreen-overlay" /> ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <StripedDataGrid
                      sx={{
                        '& .MuiDataGrid-cell[data-field="actions"]': {
                          position: 'sticky !important',
                          left: 0,
                          bgcolor: '#fff !important',
                          boxShadow: '2px 0 5px -2px rgba(0,0,0,0.21)',
                          zIndex: 2000,
                          transform: 'translateX(0)',
                          isolation: 'isolate',
                          minWidth: '150px',
                          // Ensure content stays visible
                          '& .MuiDataGrid-actionsCell': {
                            position: 'relative',
                            zIndex: 2001,
                          },
                        },
                        '& .MuiDataGrid-columnHeader[data-field="actions"]': {
                          position: 'sticky !important',
                          left: 0,
                          bgcolor: '#fff !important',
                          boxShadow: '2px 0 5px -2px rgba(0,0,0,0.21)',
                          zIndex: 2000,
                          transform: 'translateX(0)',
                          isolation: 'isolate',
                          minWidth: '150px',
                        },
                        // Add a wrapper class to ensure proper stacking context
                        '& .MuiDataGrid-main': {
                          overflow: 'visible',
                          zIndex: 1,
                        },
                        borderRadius: '20px',
                      }}
                      columns={
                        LoginInfo.skuDetail?.some(
                          (item) => item.PageName === 'Update Item Master',
                        )
                          ? column // Show all columns for SuperUser
                          : column.filter((col) => col.field !== 'actions') // Hide actions column for other roles
                      }
                      editMode="row"
                      experimentalFeatures={{ newEditingApi: true }}
                      rowModesModel={rowModesModel}
                      rows={tableData1}
                      getRowId={(row) => row.id}
                      processRowUpdate={processRowUpdate}
                      onProcessRowUpdateError={handleProcessRowUpdateError}
                      rowSelectionModel={rowSelectionModel} // for selection cnontrol
                      sortModel={sortModel}
                      onSortModelChange={(model) => setSortModel(model)}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowSelectionModelChange={handleSelectionModelChange}
                      onRowEditStop={handleRowEditStop}
                      onRowEditStart={handleRowEditStart}
                      // isCellEditable={(params) => params.row.IsEditableOnPortal === 'true'}
                      // console.log(params.row.API_Integration);
                      // return params.row.Status !== 'In Queue'
                      // && params.row.Status !== 'Error';
                      components={{
                        MuiTablePagination: {
                          styleOverrides: {
                            select: {
                              marginTop: '100px', // Adjust the margin as needed
                              marginBottom: '10px', // Adjust the margin as needed
                            },
                          },
                        },
                        Toolbar: () => CustomToolbar(tableData1, SKUTable),
                      }}
                      checkboxSelection
                      // rowsPerPageOptions={[50, 100, 200]}
                      getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0
                        ? 'even'
                        : 'odd')}
                      initialState={{
                        filter: {
                          filterModel: {
                            items: [],
                            quickFilterLogicOperator: GridLogicOperator.Or,
                          },
                        },
                      }}
                      columnBuffer={18}
                    />
                    <p
                      className="dark:text-gray-500 text-gray-700 text-center "
                      style={{ marginTop: '-30px' }}
                    >
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemMaster;
